import { c as _slicedToArray, a as _toConsumableArray, _ as _objectSpread2, f as _asyncToGenerator } from './_rollupPluginBabelHelpers-fb970440.js';
import React, { useState, useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { Modal, QuantaFormik, QuantaForm, Label, Text, Grid, GridItem, QuantaCheckbox, Button } from 'quanta-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faDownload } from '@fortawesome/free-solid-svg-icons';

function ModalDownloadQuote(_ref) {
  var _plans$filter, _plans$filter2;

  var setShowDownload = _ref.setShowDownload,
      showDownload = _ref.showDownload,
      getPayLoad = _ref.getPayLoad,
      plans = _ref.plans,
      SEND_DOWNLOAD_QUERY = _ref.SEND_DOWNLOAD_QUERY,
      productName = _ref.productName,
      quoteNumber = _ref.quoteNumber;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalDisplay = _useState2[0],
      setModalDisplay = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      displayMessage = _useState4[0],
      setDisplayMessage = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      sentSuccess = _useState6[0],
      setSentSuccess = _useState6[1];

  var _useMutation = useMutation(SEND_DOWNLOAD_QUERY, {
    onCompleted: function onCompleted(data) {
      var _data$;

      setSentSuccess(true);
      setDisplayMessage((_data$ = data["".concat(Object.keys(data)[0])]) === null || _data$ === void 0 ? void 0 : _data$.message);
      var downloadBase64String = data["".concat(Object.keys(data)[0])].base64Pdf;
      var byteCharacters = atob(downloadBase64String.toString());
      var byteNumbers = new Array(byteCharacters.length);

      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);
      var file = new Blob([byteArray], {
        type: 'application/pdf;base64'
      });
      var fileURL = URL.createObjectURL(file);

      if (productName && quoteNumber) {
        var downloadLink = document.createElement('a');
        var fileName = "".concat(productName, "-").concat(quoteNumber, ".pdf");
        downloadLink.href = fileURL;
        downloadLink.download = fileName;
        downloadLink.click();
        window.URL.revokeObjectURL(fileURL);
      } else {
        window.open(fileURL);
      }
    },
    onError: function onError(_) {
      setSentSuccess(false);
      setDisplayMessage('Downloading failed. Please try again after sometime.');
    }
  }),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      doSendQuoteEmailAlert = _useMutation2[0],
      loading = _useMutation2[1].loading;

  useEffect(function () {
    var timer = setTimeout(function () {
      setModalDisplay(showDownload);
    }, 150);
    return function cleanup() {
      clearTimeout(timer);
      setDisplayMessage(null);
      setSentSuccess(true);
    };
  }, [showDownload, setModalDisplay]);

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values) {
      var _values$plans, _values$plans$filter;

      var _values$plans2, variables;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if ((values === null || values === void 0 ? void 0 : (_values$plans = values.plans) === null || _values$plans === void 0 ? void 0 : (_values$plans$filter = _values$plans.filter(function (plan) {
                return plan === null || plan === void 0 ? void 0 : plan.isPlanChecked;
              })) === null || _values$plans$filter === void 0 ? void 0 : _values$plans$filter.length) === 0) {
                setSentSuccess(false);
                setDisplayMessage('Atleast one plan must be selected');
              } else {
                setDisplayMessage(null);
                variables = getPayLoad((_values$plans2 = values.plans) === null || _values$plans2 === void 0 ? void 0 : _values$plans2.filter(function (plan) {
                  return plan === null || plan === void 0 ? void 0 : plan.isPlanChecked;
                }));

                if (SEND_DOWNLOAD_QUERY) {
                  doSendQuoteEmailAlert({
                    variables: variables
                  });
                }
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var initialValues = {
    plans: _toConsumableArray(plans === null || plans === void 0 ? void 0 : (_plans$filter = plans.filter(function (plan) {
      return plan === null || plan === void 0 ? void 0 : plan.isSelected;
    })) === null || _plans$filter === void 0 ? void 0 : _plans$filter.map(function (plan) {
      return _objectSpread2(_objectSpread2({}, plan), {}, {
        isPlanChecked: true
      });
    }))
  };

  var validate = function validate(_) {
    return {};
  };

  var onModalClose = function onModalClose() {
    setModalDisplay(false);
    setShowDownload(false);
    document.body.classList.remove('overflow-y-hidden');
  };

  return /*#__PURE__*/React.createElement(Modal, {
    display: modalDisplay,
    size: "medium",
    title: "Download Quote",
    severity: "action",
    onClose: function onClose() {
      onModalClose();
    },
    modalCloseDisabled: loading
  }, /*#__PURE__*/React.createElement(QuantaFormik, {
    enableReinitialise: true,
    initialValues: initialValues,
    validate: validate,
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(QuantaForm, null, /*#__PURE__*/React.createElement(Label, {
    text: /*#__PURE__*/React.createElement(Text, {
      type: 'label'
    }, "Select plans for which quote to be downloaded", ' ', /*#__PURE__*/React.createElement(Text, {
      severity: 'error'
    }, "*"))
  }, /*#__PURE__*/React.createElement(Grid, {
    repeat: 3
  }, plans === null || plans === void 0 ? void 0 : (_plans$filter2 = plans.filter(function (plan) {
    return plan === null || plan === void 0 ? void 0 : plan.isSelected;
  })) === null || _plans$filter2 === void 0 ? void 0 : _plans$filter2.map(function (plan, idx) {
    return /*#__PURE__*/React.createElement(GridItem, {
      key: idx,
      colSpan: 1
    }, /*#__PURE__*/React.createElement(QuantaCheckbox, {
      name: "plans[".concat(idx, "].isPlanChecked"),
      label: "".concat(plan === null || plan === void 0 ? void 0 : plan.name),
      disabled: loading
    }));
  }))), displayMessage && !loading ? /*#__PURE__*/React.createElement(Text, {
    severity: sentSuccess ? 'success' : 'error'
  }, displayMessage) : null, /*#__PURE__*/React.createElement(Button, {
    size: "full",
    type: "submit",
    className: "mt-4",
    disabled: loading,
    iconPre: loading ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faSpinner,
      spin: true,
      className: "ml-2"
    }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faDownload,
      className: "ml-2"
    })
  }, loading ? "Downloading..." : "Download Quote"))));
}

export default ModalDownloadQuote;
